<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xm(:title="$t('sec1')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        p {{ item }}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}


  section.u-mt-md
    AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")

    .grid.is-desktop-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
        h4 {{item.name}}


  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"iOS meetup",
    "pageDesc":"Join the iOS geeks in a sessions that stimulates your analytical skills.",
    "mantra":"iOS meetup",
    "mantraDesc":"Introduce yourself to cutting edge technologies. Network with iOS experts and get inspiration for your next project in Baianat meetup that is tailored for iOS developers.",
    "sec1":"Why we are holding this meetup?",
    "sec1Items":{
      "1":"Getting the iOS developers community along under one roof for an opportunity of bringing the best possible in the technology and sharing resources of actual benefit."
    },
    "sec2":"The meetup agenda",
    "sec2Items":{
      "1":{
        "title":"OS app architecture  ",
        "desc":"Learn our hacks on how to build an App that can be easily maintained and upgraded even with hundreds of downloads."
      },
      "2":{
        "title":"Code labs ",
        "desc":"Bring your laptop and get ready for implementation of the latest hacks and tricks. Attend our libraries launch and share your inputs."
      }
    },
    "sec3":"Meetup |speakers",
    "sec3Items":{
      "1":{
        "name":"Mostafa Wahba"
      },
      "2":{
        "name":"Ahmed Alaa"
      },
      "3":{
        "name":"Mohamed Ahmed"
      }
    },
    "cta":"Registration will <br> be open soon."
  },
  "ar": {
    "pageTitle":"ملتقى آي أو إس",
    "pageDesc":"انضم إلى المهتمين بأمر  آي أو إس من خلال ملتقى آي أو إس الذي يساعدك على الحصول على كل المعلومات التحفيزية التي تحتاج إليها.",
    "mantra":"ملتقى آي أو إس",
    "mantraDesc":"تعرف على أحدث التقنيات آي أو إس التي تشغل بالك. تواصل مع خبراء آي أو إس واحصل على المصادر الملهمة التي تساعدك في مشروعك القادم من خلال ملتقى بيانات المخصص لمطوري آي أو إس.",
    "sec1":"لماذا نعقد هذا الملتقى؟",
    "sec1Items":{
      "1":"جمع مع مطوري آي أو إس في مكان واحد واحصل على الفرص كاملة لمعرفة أحدث التقنيات التكنولوجية المستخدمة وكذلك مشاركة مختلف المصادر ذات الفائدة."
    },
    "sec2":"أجندة الملتقى",
    "sec2Items":{
      "1":{
        "title":"بنية تطبيق OS  ",
        "desc":"تعرف على النصائح الخاصة بنا حول كيفية إنشاء تطبيق يمكن صيانته وترقيته بسهولة حتى مع مئات التنزيلات."
      },
      "2":{
        "title":"مختبرات البرمجة ",
        "desc":"احضر اللاب توب الخاص بك وكن على استعداد لتنفيذ مختلف النصائح والخطوات. تابع انطلاق المكتبات الخاصة بنا وتبادل معنا مدخلاتك."
      }
    },
    "sec3":"متحدثو |الملتقى",
    "sec3Items":{
      "1":{
        "name":"مصطفي وهبة"
      },
      "2":{
        "name":"أحمد علاء"
      },
      "3":{
        "name":"محمد أحمد"
      }
    },
    "cta":"التسجيل سوف يكون <br> متاح قريبًا"
  }
}
</i18n>
